<template>
  <div class="test-list">
    <div class="list-body">
      <div class="thead">
        <table>
          <colgroup>
            <col>
            <col style="width: 22.5%">
            <col style="width: 51%">
            <col>
          </colgroup>
          <thead>
          <tr>
            <th class="gap"></th>
            <th v-for="column in useHeaders" :key="`${column.value}`"
                :class="`th-${column.value}`"
                @click="changeSort(column.value)">
              {{column.name}}
              <button class="sort"
                      :class="{ active: testResultList.length && computedSort === column.value,
                                    asc: order,
                                    desc: !order }">
                <i class="icon icon--sort-asc"></i>
                <i class="icon icon--sort-desc"></i>
              </button>
            </th>
            <th class="gap"></th>
          </tr>
          </thead>
        </table>
      </div>
      <div class="tbody" v-if="testResultList.length">
        <table>
          <tbody>
            <tr v-for="item in testResultList" :key="item.id">
              <td class="gap"></td>
              <td style="width: 22.5%"><div class="td-data">{{item.testKey}}</div></td>
              <td style="width: 51%"><div class="td-data">{{item.title}}</div></td>
              <td>
                <div class="td-data" :class="{result: true}">
                  <i v-if="item.result === 'passed'" class="icon icon--passed"/>
                  <i v-else-if="item.result === 'failed'" class="icon icon--failed"/>
                  <i v-else-if="item.result === 'error'" class="icon icon--error"/>
                  <i v-if="item.result === 'skipped'" class="icon icon--skipped"/>
                  <div class="result-text"
                       :class="{passed: item.result === 'passed', failed: item.result === 'failed', skipped: item.result === 'skipped', error: item.result === 'error'}">
                    {{resultValue(item.result)}}
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="tbody" :class="'no-data'" v-else>
        <div class="no-result">
          {{$t('testResult.scenario.noResult')}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {TEST_RESULT_MAP} from '@/libs/constants'
export default {
  name: 'TestResultList',
  props: ['testResultList'],
  components: {

  },
  computed: {
    computedSort () {
      return this.listOption.sort.replace('-', '')
    },
    order () {
      return !this.listOption.sort.includes('-')
    },
  },
  methods: {
    changeSort (sort) {
      if (this.listOption.sort === '-' + sort) {
        this.listOption.sort = sort
      } else {
        this.listOption.sort = '-' + sort
      }
      this.sortInList()
    },
    sortInList () {
      let listData = this.testResultList
      listData.sort((a, b) => {
        if (typeof a[this.computedSort] === 'string' && typeof b[this.computedSort] === 'string') {
          if (this.order) {
            // return a[this.computedSort].toString().localeCompare(b[this.computedSort].toString())
            return new Intl.Collator('en').compare(a[this.computedSort].toString(), b[this.computedSort].toString())
          } else {
            // return b[this.computedSort].toString().localeCompare(a[this.computedSort].toString())
            return new Intl.Collator('en').compare(b[this.computedSort].toString(), a[this.computedSort].toString())
          }
        } else {
          if (this.order) {
            return a[this.computedSort] > b[this.computedSort] ? 1 : -1
          } else {
            return b[this.computedSort] > a[this.computedSort] ? 1 : -1
          }
        }
      })
    },
    resultValue(result) {
      return TEST_RESULT_MAP[result]
    }
  },
  data () {
    return {
      listOption: {
        // pageNum: 1,
        // itemsPerPage: 50,
        sort: 'testKey'
      },
      useHeaders: [
        {
          name: this.$t('testSetting.testKey'),
          // sortable: true,
          value: 'testKey'
        },
        {
          name: this.$t('testSetting.title'),
          // sortable: true,
          value: 'title'
        },
        {
          name: this.$t('testResult.scenario.result'),
          // sortable: true,
          value: 'result'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.test-list {
  position: relative;
  height: 100%;

  .list-body {
    z-index: 1;
    position: relative;
    height: calc(100% - 106px);
    .thead {
      height: 55px;
    }

    .tbody {
      min-height: 592px;
      position: relative;
      max-height: calc(100% - 68px);
      padding-bottom: 12px;
      overflow: auto;
      &.no-data {
        text-align: center;
        .no-result {
          margin-top: 25%;
          font-size: 15px;
          font-weight: 600;
        }
      }
    }
    table {
      position: relative;
      width: 100%;
      border-spacing: 0px;
      thead {
        tr {
          th {
            height: 39px;
            font-size: 13px;
            font-weight: normal;
            background: #333333;
            color: #ffffff;
            padding: 9px 22px 7px 15px;
            vertical-align: bottom;
            text-align: left;
            line-height: 20px;
            transition: background-color 0.15s ease;
            white-space: nowrap;

            .icon {
              vertical-align: middle;
              margin: -1px 5px 1px 0;
              cursor: pointer;
            }

            &:first-child {
              border-left: 0;
              box-shadow: inset 1px 0 0 rgba(0, 0, 0, 0.15);
            }

            &.gap {
              padding: 0;
              width: 28px;
              border-bottom: none;
            }

            .sort {
              display: inline-block;
              width: 14px;
              height: 18px;
              padding: 1px 0;
              margin-top: -2px;
              margin-left: 2px;
              vertical-align: middle;
              border-radius: 4px;
              transition: background-color 0.15s ease,
              box-shadow 0.15s ease;

              i.icon {
                float: left;
                opacity: 0.2;
                transition: opacity 0.15s ease;
              }

              &.active {
                &.asc {
                  .icon--sort-asc {
                    opacity: 1;
                  }
                }

                &.desc {
                  .icon--sort-desc {
                    opacity: 1;
                  }
                }
              }

              &.active {
                background-color: #272727;
                box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.146);
              }
            }

            &.hover {
              .sort {
                background-color: #272727;
                box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.146);
              }
            }

            &:last-child {
              border-radius: 0 7px 7px 0;
            }
          }
        }
      }
      tbody {
        position: relative;
        height: 1px;
        td {
          height: 100%;
          text-align: left;
          font-size: 13px;
          line-height: 1.31;
          letter-spacing: normal;
          color: #444;
          word-break: break-all;
          border-bottom: 1px solid #ebebeb;
          vertical-align: top;
          .td-data {
            position: relative;
            height: 100%;
            padding: 17px 15px 17px 15px;
            box-sizing: border-box;
            &.result {
              display: flex;
              .result-text {
                margin-left: 10px;
                margin-top: 2px;
                font-weight: 600;

                &.passed {
                  color: #56B527;
                }
                &.failed {
                  color: #E92020;
                }
                &.skipped {
                  color: #FF8400;
                }
                &.error {
                  color: #888888;
                }
              }
            }
          }
          &.gap {
            width: 25px;
          }
        }
      }
    }
  }
}

</style>
